<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" >
  <div>
    {{"pay_with_card" | translate}}
  </div>
</div>

<mat-divider class="-mx-6 text-border"></mat-divider>

<mat-dialog-content >
  <div class="flex flex-col" [formGroup]="form">

    <mat-form-field appearance="outline" class="mt-1 flex-auto">
      <mat-label>{{"amount" | translate}}</mat-label>
      <input type="text" matInput required/>
    </mat-form-field>


  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button button color="primary" mat-raised-button type="button" (click)="submit()">{{"pay" | translate}}</button>
</mat-dialog-actions>
